import PostsGrid from '../components/Grid';
import { PostProvider } from '../store';

export default function PostsGridLayout() {
  return <PostProvider>
    <PostsGrid />
  </PostProvider>;
}
